import React from 'react';

const IsDisabledContext = React.createContext<boolean>(false);

export type IsDisabledProviderOwnProps = {
    isDisabled: boolean;
    children: React.ReactNode;
};

export type IsDisabledProviderProps = IsDisabledProviderOwnProps;

const IsDisabled: React.FC<IsDisabledProviderProps> = (props) => {
    const isDisabledByParent = useIsDisabledByParent();
    return (
        <IsDisabledContext.Provider value={props.isDisabled || isDisabledByParent}>
            {props.children}
        </IsDisabledContext.Provider>
    );
};

export default React.memo(IsDisabled);

export const useIsDisabledByParent = (inputIsDisabled?: boolean): boolean => {
    return React.useContext(IsDisabledContext) || !!inputIsDisabled;
};
